import { supabase } from '@/lib/supabase'

/**
 * Upload a PDF blob to the project-documents bucket and create a record in project_documents.
 * Non-bloquant: l'appelant doit wrapper dans un try/catch.
 */
export async function savePdfToProjectDocuments(
  projectId: string,
  pdfBlob: Blob,
  fileName: string,
  categorie: 'contrat' | 'facture',
  description: string
): Promise<void> {
  const storagePath = `${projectId}/${Date.now()}_${Math.random().toString(36).substring(7)}.pdf`

  const { error: uploadError } = await supabase.storage
    .from('project-documents')
    .upload(storagePath, pdfBlob, { contentType: 'application/pdf' })

  if (uploadError) {
    throw new Error(`Upload PDF échoué: ${uploadError.message}`)
  }

  const { data: urlData, error: urlError } = await supabase.storage
    .from('project-documents')
    .createSignedUrl(storagePath, 3600)
  if (urlError) {
    console.warn('Error signing project document URL:', urlError)
  }

  const { error: insertError } = await supabase
    .from('project_documents')
    .insert({
      project_id: projectId,
      nom: fileName,
      description,
      type: 'application/pdf',
      categorie,
      url: urlData?.signedUrl ?? '',
      taille: pdfBlob.size,
    })

  if (insertError) {
    // Nettoyer le fichier uploadé si l'insertion échoue
    await supabase.storage.from('project-documents').remove([storagePath])
    throw new Error(`Insert document échoué: ${insertError.message}`)
  }
}
